module.exports = __webpack_public_path__ + "img/V-R-246-unload-standup-top.a8c5a36c.png";